exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w-24R[data-v-b45c7eb2] {\n\twidth: 24rem;\n}\n", ""]);

// exports
